export const NOTIFICATIONS_EVENTS = {
  NOTIFICATION_OPENED: "Notification Opened",
  NOTIFICATION_CLICKED: "Notification Clicked",
};

export const NOTIFICATIONS_EVENTS_PARAMS = {
  NOTIFICATION_TYPE: "notification_type",
};

export const NOTIFICATIONS_EVENTS_VALUES = {
  CONSUMER: {
    TRANSACTIONS: "consumer_transactions_email_notification",
    QUICK_LINKS_CREATION: "consumer_quick_links_creation_notification"
  },
  MERCHANT: {
    TRANSACTIONS: "merchants_transactions_email_notification",
  }
};
